/**
 * Created by hp on 2017/6/6.
 */
const defaults = {
    initialized: false,
    showGiftBar: false,
    showGiftBarTips: false,
    giftNum: 1,
    showPayPanel: false,
    showChat: false,
    showCoupon: false,
    showLecturer: false,
    selectPay: 0,
    showOperatePanel: false,
    isSelectSingleLecture: true,
    isSelectSingleChannel: false,
    isSelectMonthChannel: false,
    showDiscountPayPanel: false,
    priceRecordId: 0,
    showRelayDialog: false,
    discount: {},
    hasBuyGift: false,
    isShowMedalModal: false,
    medalType: '',
    videoShow: true,
};

export default(state = defaults, action) => {
    switch (action.type) {
        case 'LECTURE_INIT':
            return {...state, initialized: true, ...action.payload};
        case 'LECTURE_SET_FANS':
            state.role.is_fans = true;
            return {...state};
        case 'LECTURE_UNSET_FANS':
            state.role.is_fans = false;
            return {...state};
        case 'LECTURE_SET_FAVOURITE':
            state.role.is_favorited = action.payload == null ? true : action.payload;
            return {...state};
        case 'LECTURE_UNSET_FAVOURITE':
            state.role.is_favorited = false;
            return {...state};
        case 'LECTURE_SHOW_GIFT_BAR':
            return {...state, showGiftBar: true};
        case 'LECTURE_HIDE_GIFT_BAR':
            return {...state, showGiftBar: false};
        case 'LECTURE_SHOW_GIFT_BAR_TIPS':
            return {...state, showGiftBarTips: true};
        case 'LECTURE_HIDE_GIFT_BAR_TIPS':
            return {...state, showGiftBarTips: false};
        case 'LECTURE_SET_GIFT_NUM':
            return {...state, ...action.payload};
        case 'LECTURE_SET_GRANTED':
            return {...state, ...action.payload};
        case 'LECTURE_UNSET_GRANTED':
            return {...state, ...action.payload};
        case 'LECTURE_SHOW_PAY_PANEL':
            return {...state, showPayPanel: true};
        case 'LECTURE_HIDE_PAY_PANEL':
            return {...state, showPayPanel: false};
        case 'LECTURE_SHOW_CHAT':
            return {...state, showChat: true};
        case 'LECTURE_HIDE_CHAT':
            return {...state, showChat: false};
        case 'LECTURE_SHOW_LECTURER_DIALOG':
            return {...state, showLecturer: true, ...action.payload};
        case 'LECTURE_HIDE_LECTURER_DIALOG':
            return {...state, showLecturer: false, ...action.payload};
        case 'LECTURE_SHOW_DISCOUNT_PANEL':
            return {...state, showCoupon: true};
        case 'LECTURE_HIDE_DISCOUNT_PANEL':
            return {...state, showCoupon: false};
        case 'LECTURE_SET_SELECT_PAY':
            let selectMonthId = action.payload;
            let priceList = state.channel.price_list.map((item) => {
                item.selected = selectMonthId === item.id;
                return item;
            });
            state.channel.price_list = priceList;
            return {
                ...state,
                channel: state.channel,
                isSelectSingleLecture: false,
                isSelectSingleChannel: false,
                isSelectMonthChannel: true,
                priceRecordId: action.payload,
            };
        case 'LECTURE_SET_SINGLE_LECTURE_PAY':
            if (state.channel && !state.channel.is_cost_fix) {
                state.channel.price_list = state.channel.price_list.map((item) => {
                    item.selected = false;
                    return item;
                });
                return {
                    ...state,
                    channel: state.channel,
                    isSelectSingleLecture: true,
                    isSelectSingleChannel: false,
                    isSelectMonthChannel: false,
                };
            } else {
                return {
                    ...state,
                    isSelectSingleLecture: true,
                    isSelectSingleChannel: false,
                    isSelectMonthChannel: false
                };
            }
        case 'LECTURE_SET_SINGLE_CHANNEL_PAY':
            return {...state, isSelectSingleLecture: false, isSelectSingleChannel: true, isSelectMonthChannel: false};
        case 'LECTURE_SHOW_OPERATE_PANEL':
            return {...state, showOperatePanel: true};
        case 'LECTURE_HIDE_OPERATE_PANEL':
            return {...state, showOperatePanel: false};
        case 'LECTURE_LIMIT_MONEY_OVER':
            state.lecture.limit_money = null;
            return {...state};
        case 'LECTURE_SHOW_DISCOUNT_PAY_PANEL':
            return {...state, showDiscountPayPanel: true, showPayPanel: true};
        case 'LECTURE_HIDE_DISCOUNT_PAY_PANEL':
            return {...state, showDiscountPayPanel: false, showPayPanel: false};
        case 'LECTURE_SHOW_RELAY_DIALOG':
            return {...state, showRelayDialog: true};
        case 'LECTURE_HIDE_RELAY_DIALOG':
            return {...state, showRelayDialog: false};
        case 'LECTURE_SET_DISCOUNT':
            return {...state, discount: action.payload};
        case 'LECTURE_SET_BUY_GIFT':
            return {...state, hasBuyGift: action.payload};
        case 'LECTURE_SET_IS_SHOW_MEDAL_MODAL':
            return {...state, isShowMedalModal: action.payload};
        case 'LECTURE_SET_MEDAL_TYPE':
            return {...state, medalType: action.payload};
        case 'LECTURE_SHOW_VIDEO':
            return {...state, videoShow: true};
        case 'LECTURE_HIDE_VIDEO':
            return {...state, videoShow: false};
        case 'LECTURE_CHANGE_CHANNEL_SVIP_SUCCESS':
            state.channel_access.granted = true;
            return {...state, channel_access: Object.assign({}, state.channel_access)}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/lecture.js